import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full h-screen relative flex bg-[#EFEEEC] pr-[20px]" }
const _hoisted_2 = {
  key: 0,
  class: ""
}
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = {
  key: 1,
  class: "flex items-center justify-center mt-20"
}

import TerminVIew from "./TerminVIew.vue";
import { useRoute } from "vue-router";
import client from "@/utils/axios";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import SpinnerLoader from "@/components/Loaders/SpinnerLoader.vue";
import { createClient } from "@supabase/supabase-js";
import PhaseSidemenu from "@/components/Sidebar/Redesign/PhaseSidemenu.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import SecondaryPageHeader from "@/components/PageHeader/SecondaryPageHeader.vue";
import { useUserStore } from "@/stores/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'TerminPage',
  setup(__props) {

const route = useRoute();
const termin = ref<any>([]);
const project = ref();
const selectedTermin = ref();
const selectedPhase = ref();
const isLoading = ref(false);
const isIssuesFeatureFlagActive = ref<boolean>(false);
const userStore = useUserStore();
let currentLanguage = computed(() => userStore.language);
let lastDatabaseTranslationUpdateTimestamp = computed(
  () => userStore.translationsUpdateTimestamp
);

const getTerminData = async () => {
  isLoading.value = true;
  try {
    const response = await client.get(
      `/projects/${route.params.id}/termin/${route.params.terminId}?locale=${currentLanguage.value}`
    );
    termin.value = response.data;

    let newSelectedPhase = "";

    termin.value.phases.forEach((phase: any) => {
      phase.termins.forEach((termin: any) => {
        if (termin.id === route.params.terminId) {
          newSelectedPhase = phase.phase.id;
          if (selectedPhase.value != newSelectedPhase) {
            selectedPhase.value = newSelectedPhase;
          }
        }
      });
    });
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

watch(
  () => route.params.terminId, // Watch for the 'id' param change in the route
  (newId, oldId) => {
    if (newId !== oldId) {
      getTerminData();
      selectedTermin.value = newId;
    }
  },
  { immediate: true } // Immediately run on component mount
);

const getProjectData = async () => {
  try {
    const response = await client.get(
      `/projects/${route.params.id}?locale=${currentLanguage.value}`
    );
    project.value = response.data;
    isIssuesFeatureFlagActive.value = response.data.isIssuesFeatureFlagActive;
  } catch (error) {
    console.log(error);
  }
};

let supabase = createClient(
  process.env.VUE_APP_SUPABASE_URL || "",
  process.env.VUE_APP_SUPABASE_API_KEY || ""
);

const handleFeatureFlag = (payload: any) => {
  if (payload) {
    isIssuesFeatureFlagActive.value = payload.new?.is_active;
  }
};

onMounted(() => {
  getProjectData();

  supabase
    .channel("feature_flag_issues")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "feature_flag",
        filter: `id=eq.1`,
      },
      handleFeatureFlag
    )
    .subscribe();
});

onUnmounted(() => {
  supabase.removeAllChannels();
});

const salesforceLink = computed(() => {
  if (termin.value) {
    return `https://smalt.lightning.force.com/lightning/r/Phase__c/${termin.value?.notionId}/view`;
  }
  return null;
});

watch(
  currentLanguage,
  async (newLang: any, oldLang: any) => {
    if (newLang && oldLang && newLang !== oldLang) {
      await getProjectData();
      await getTerminData();
    }
  },
  { immediate: true }
);
watch(
  lastDatabaseTranslationUpdateTimestamp,
  async (newTimestamp: any, oldTimestamp: any) => {
    if (newTimestamp && oldTimestamp && newTimestamp !== oldTimestamp) {
      await getProjectData();
      await getTerminData();
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(SecondaryPageHeader, {
        "appointment-project": project.value,
        "appointment-details": termin.value,
        "salesforce-link": salesforceLink.value
      }, null, 8, ["appointment-project", "appointment-details", "salesforce-link"]),
      _createElementVNode("div", _hoisted_1, [
        (termin.value.phases)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (termin.value && termin.value.phases)
                ? (_openBlock(), _createBlock(PhaseSidemenu, {
                    key: 0,
                    "appointment-page": termin.value.phases,
                    "is-loading": isLoading.value
                  }, null, 8, ["appointment-page", "is-loading"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (!isLoading.value)
            ? (_openBlock(), _createBlock(TerminVIew, {
                onRefresh: getTerminData,
                termin: termin.value,
                key: termin.value,
                "project-name": project.value?.name,
                "is-issues-feature-flag-active": isIssuesFeatureFlagActive.value
              }, null, 8, ["termin", "project-name", "is-issues-feature-flag-active"]))
            : _createCommentVNode("", true),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(SpinnerLoader)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})